
import * as React from 'react';
import { useRef } from 'react';
import isBrowser from '../services/isBrowser';
import { useElementSize } from './useElementSize';

export const useDraggableContainer = (scrollRef: any, checkJustified?: boolean) => {
    const position = React.useRef({ top: 0, left: 0, x: 0, y: 0 })
    const [isDragging, setIsDragging] = React.useState(false);
    const [needEdgeOverlay, setNeedEdgeOverlay] = React.useState<{ left: boolean, right: boolean }>({ left: false, right: false })
    const width = useElementSize({ ref: scrollRef, useHeight: false });
    const wasJustified = useRef();
    const mouseDownHandler = (e: any) => {
        scrollRef.current.style.cursor = 'grabbing';
        scrollRef.current.style.userSelect = 'none';
        position.current = {
            left: scrollRef?.current?.scrollLeft,
            top: scrollRef?.current?.scrollTop,
            x: e.clientX,
            y: e.clientY
        }
        setIsDragging(true);
    }

    const mouseMoveHandler = (e: any) => {
        setIsDragging(true);
        const mouseMoveX = e.clientX - position.current.x;
        const mouseMoveY = e.clientY - position.current.y;

        scrollRef.current.scrollLeft = position.current.left - mouseMoveX;
        scrollRef.current.scrollTop = position.current.top - mouseMoveY;

    }

    const mouseUpHandler = (e: any) => {
        scrollRef.current.style.cursor = 'grab';
        scrollRef?.current?.style.removeProperty('user-select');
        setIsDragging(false);
    }



    const updateEdgeOverlay = (): void => {
        if (!isBrowser() || !scrollRef?.current) return;
        const { offsetWidth, scrollLeft, scrollWidth } = scrollRef.current;
        let needOverlayLeft = false;
        let needOverlayRight = false;
        if (offsetWidth >= scrollWidth) {
            return updateEdgeOverlayState({ needOverlayLeft, needOverlayRight });
        }
        needOverlayLeft = scrollLeft > 4;
        needOverlayRight = (scrollWidth - offsetWidth - scrollLeft) > 4;
        return updateEdgeOverlayState({ needOverlayLeft, needOverlayRight });
    }

    const updateEdgeOverlayState = ({ needOverlayLeft, needOverlayRight }): void => {

        if ((needOverlayLeft === needEdgeOverlay.left) && (needOverlayRight === needEdgeOverlay.right)) return;

        setNeedEdgeOverlay({ left: needOverlayLeft, right: needOverlayRight });
    }



    React.useEffect(() => {
        updateEdgeOverlay();
    }, [width]);

    React.useEffect(() => {
        if (!isBrowser() || !scrollRef?.current || !checkJustified) return;
        const isJustified = scrollRef.current.classList.contains("justify-center");
        if (isJustified || isJustified !== wasJustified.current) {
            console.log('recheck')
            updateEdgeOverlay();
        }
        wasJustified.current = isJustified;
    });



    React.useEffect(() => {
        if (isDragging) document.addEventListener('mousemove', mouseMoveHandler)
        return () => document.removeEventListener('mousemove', mouseMoveHandler)
    }, [isDragging]);



    React.useEffect(() => {
        if (!isBrowser() || !scrollRef?.current) return;
        scrollRef.current.addEventListener('mousedown', mouseDownHandler);
        scrollRef.current.addEventListener('mouseup', mouseUpHandler);
        scrollRef.current.addEventListener('scroll', updateEdgeOverlay);
        return () => {
            if (!isBrowser() || !scrollRef?.current) return;
            scrollRef.current.removeEventListener('mousedown', mouseDownHandler);
            scrollRef.current.removeEventListener('mouseup', mouseUpHandler);
            scrollRef.current.removeEventListener('scroll', updateEdgeOverlay);
        }
    }, [scrollRef])
    return { needEdgeOverlay, isDragging };
}